import { Directive, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { HighlightOverlayBubblesComponent } from '@common/listing-preview/highlight-overlay-bubbles/highlight-overlay-bubbles.component';
import { Utils } from '../services/helpers/utils';
import { SharedDataService } from '../services/shared-data.service';

@Directive({
  selector: '[hoverHighlightInfo]',
})
export class HoverInfoHighlightDirective {
  @Input() elementData: any; // Element se related data
  @ViewChild('overlayBubble') overlayBubble: HighlightOverlayBubblesComponent;

  constructor(
    private el: ElementRef,
    private sharedDataService: SharedDataService
  ) {}

  @HostListener('mouseover', ['$event']) onMouseOver(event: MouseEvent) {
    event?.stopPropagation();
    if (this.el.nativeElement && event.ctrlKey) {
      this.el.nativeElement?.classList?.add('highlighted-section'); // Highlight color
      this.el.nativeElement.style.cursor = 'crosshair';
    } else {
      this.el.nativeElement?.classList?.remove('highlighted-section');
      this.el.nativeElement.style.cursor = 'default'; // Original cursor
    }
  }

  @HostListener('mouseenter', ['$event']) onMouseEnter(event: MouseEvent) {
    event?.stopPropagation();
    if (this.el.nativeElement && event.ctrlKey) {
      this.el.nativeElement?.classList?.add('highlighted-section'); // Highlight color
      this.el.nativeElement.style.cursor = 'crosshair';
    } else {
      this.el.nativeElement?.classList?.remove('highlighted-section');
      this.el.nativeElement.style.cursor = 'default'; // Original cursor
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.el.nativeElement?.classList?.remove('highlighted-section');
    this.el.nativeElement.style.cursor = 'default'; // Original cursor
  }

  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    event?.stopPropagation();
    if (event.ctrlKey) {
      let popupModalContainer =
        document.querySelector('.bubble-outer-container.referenced-bubble .confirmation-dialog-container') || document.querySelector('body');
      if (popupModalContainer) {
        const { scrollTop, scrollLeft } = popupModalContainer; // Element's position
        const { left, top } = popupModalContainer.getBoundingClientRect(); // Element's position
        const x = event.clientX - left + scrollLeft - 30;
        const y = event.clientY - top + scrollTop - 120;
        let newCommentBubble = {
          id: this.el.nativeElement?.id || '',
          comments: [],
          position: { x: x, y: y },
          is_resolved: false,
          reference_id: Utils.generateUUID(),
          is_resolved_by_admin: false,
        };
        let bubbleContainer = document.querySelectorAll(`.bubble-container`) as NodeListOf<Element>;
        bubbleContainer?.length > 0 && bubbleContainer.forEach(node => node?.remove());
        this.sharedDataService.overlayBubble.bubbles.push(newCommentBubble);
        this.sharedDataService.overlayBubble.bubbles = this.sharedDataService.overlayBubble.bubbles?.map((value, index) => {
          value = { ...value, label: index + 1 };
          return value;
        });
        if (popupModalContainer.tagName?.toLowerCase() === 'body') {
          document.documentElement.scrollTop = 5;
          document.documentElement.scrollTop = -5;
        } else {
          popupModalContainer?.scrollBy(0, 5);
          popupModalContainer?.scrollBy(0, -5);
        }

        // open overlay panel when added
        setTimeout(() => {
          let bubbleContainer = document.querySelector(`[data-bubble-ref="${newCommentBubble?.reference_id}"]`) as HTMLElement;
          bubbleContainer && bubbleContainer?.click();
        }, 0);
      }
    } else if (!(event.target as HTMLElement).classList.contains('bubble-container') && this.el.nativeElement?.id?.startsWith('listing-')) {
      this.sharedDataService.overlayBubble.overlaypanel.hide();
    }
  }
}
